import { client } from "service/service";

export const getUser = async (id: string) => {
  try {
    const res = await client.get(`users/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const login = async (email: string, password: string) => {
  try {
    const res = await client.post(`auth/login`, { email, password });
    return res.data;
  } catch (err) {
    throw err;
  }

}

export const getUsers = async () => {
  try {
    const res = await client.get(`users`);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const patchUserRoles = async (id: string, roles: string[]) => {
  try {
    const res = await client.patch(`users/${id}/roles`, { roles });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const postCreateUser = async (email: string, password: string, isAdmin: boolean, roles: any[]) => {
  try {
    const res = await client.post(`users`, { email, password, isAdmin, roles: roles });
    return res.data;
  } catch (err) {
    throw err;
  }
}

export const deleteUser = async (id: string) => {
  try {
    const res = await client.delete(`users/${id}`);
    return res.data;
  } catch (err) {
    throw err;
  }
}
